module.exports = __webpack_public_path__ + "static/IMG_2611-61e033f6bc928e7a80ae246748d1bde9.jpg";